import { Tag } from 'glints-aries/lib/@next';
import { Neutral } from 'glints-aries/lib/@next/utilities/colors';
import styled from 'styled-components';

export const Title = styled.h2`
  margin-bottom: 16px;

  font-size: 16px;
  font-weight: bold;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TagOverride = styled(Tag)`
  span {
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-color: ${Neutral.B95};
  }
`;
